import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { downloadReportPdf, type ReportDateRangeParameters } from '@/api/reports/reportsApi';
import type { DownloadedFile } from '@/api/fileDownload';

export function useViewReportPdf(): UseMutationResult<
  DownloadedFile,
  Error,
  ReportDateRangeParameters
> {
  return useMutation({
    mutationFn: function requestReportPdf(dateRange: ReportDateRangeParameters) {
      return downloadReportPdf(dateRange);
    },
  });
}
